import { useEffect, useState } from 'react';
import { fetchSubscribers, deleteSubscriber, type Subscriber } from './api';

export default function AdminNewsletter() {
  const [subscribers, setSubscribers] = useState<Subscriber[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const subs = await fetchSubscribers();
        if (!cancelled) {
          setSubscribers(subs);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setError('Failed to load subscribers');
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleDelete = async (id: string) => {
    if (!window.confirm('Are you sure you want to remove this subscriber?')) return;
    try {
      await deleteSubscriber(id);
      setSubscribers(subscribers.filter(s => s._id !== id));
    } catch (err) {
      alert('Failed to delete subscriber');
    }
  };

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <div>
          <h1>Newsletter Subscribers</h1>
          <p className="admin-muted">View and manage email subscribers.</p>
        </div>
      </header>

      {error && <p className="admin-error">{error}</p>}

      <div className="admin-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, fontSize: '1.25rem' }}>Subscribers List</h2>
          <span className="admin-muted">{subscribers.length} Emails</span>
        </div>
        
        {loading ? (
          <p>Loading subscribers...</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Email Address</th>
                  <th>Subscribed Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {subscribers.length === 0 ? (
                  <tr>
                    <td colSpan={3} style={{ textAlign: 'center' }}>No subscribers yet.</td>
                  </tr>
                ) : (
                  subscribers.map(sub => (
                    <tr key={sub._id}>
                      <td><strong>{sub.email}</strong></td>
                      <td>{new Date(sub.subscribedAt).toLocaleString()}</td>
                      <td>
                        <button 
                          className="admin-btn admin-btn-danger" 
                          onClick={() => handleDelete(sub._id)}
                          style={{ padding: '6px 12px', fontSize: '12px' }}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
